import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { Org, fetchOrg as apiFetchOrg } from 'api/orgs';
import { setError } from 'modules/main/store/ducks/error';

export type MainStoreOrgsStateOrg = Org & {
  isFetching: boolean;
  isUnpublished: boolean;
};

export type MainStoreOrgsState = {
  byId: Record<string, Partial<MainStoreOrgsStateOrg>>;
};

export const fetchOrg = createAsyncThunk<Org, string>(
  'orgs/fetchOrg',
  // @ts-expect-error TS(2345): Argument of type '(orgId: string, thunkAPI: GetThu... Remove this comment to see the full error message
  async (orgId: string, thunkAPI) => {
    try {
      const fetchedOrg = await apiFetchOrg(orgId);
      return fetchedOrg as MainStoreOrgsStateOrg;
    } catch (e) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (e.statusCode !== 404) {
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        thunkAPI.dispatch(setError(e));
      } else {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        thunkAPI.dispatch(setOrgUnpublished(orgId));
      }
    }
  }
);

export const { actions, reducer } = createSlice({
  name: 'orgs',
  initialState: {
    byId: {},
  },
  reducers: {
    setOrgUnpublished: (state: MainStoreOrgsState, action) => {
      state.byId[action.payload].isFetching = false;
      state.byId[action.payload].isUnpublished = true;
    },
    updateOrg: (state, action) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      state.byId[action.payload.id] = action.payload;
    },
    partialUpdateOrg: (state, action) => ({
      ...state,
      byId: {
        ...state.byId,
        [action.payload.id]: {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          ...state.byId[action.payload.id],
          ...action.payload,
        },
      },
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrg.pending, (state: MainStoreOrgsState, action) => {
        state.byId[action.meta.arg] = {
          id: action.meta.arg,
          isFetching: true,
        };
      })
      .addCase(fetchOrg.fulfilled, (state, action) => {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        state.byId[action.meta.arg].isFetching = false;

        // If a listing is unpublished, the action technically
        // is fulfilled, but there is no payload, so we
        // don't set it here, letting the `setOrgUnpublished`
        // action handle the state change.
        if (action.payload) {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          state.byId[action.meta.arg] = action.payload;
        }
      });
  },
});

export const { updateOrg, setOrgUnpublished, partialUpdateOrg } = actions;
